<div *ngIf="records != null && records.length > 0" style="display: flex; flex-direction: column; height: 100%;">
  <ag-grid-angular #kvGrid
    id="grid1"
    style="flex-grow: 1; width: 100%; height: 100%;"
    class="grid full overflow-grid"
    [gridOptions]="gridOptions"
    [rowData]="records"
    [columnDefs]="columns"
    [defaultColDef]="defaultColDef"
    [pagination]="false"
    (gridReady)="onGridReady($event)"
  />
</div>
